<template>
  <router-link class="btn btn-plain" :to="{ name: rights.includes('crm') ? 'CRMSalesFunnelApplications' : 'CRMTasks'}">
    <PhoneSvg/>
    <span class="d-none d-xl-inline header-title">{{ $t('crm') }}</span>
  </router-link>
</template>

<script setup>
import PhoneSvg from '@/assets/svg-vue/header/phone.svg'
import { computed } from "vue"
import { useStore } from "vuex"

const store = useStore()

const rights = computed(() => store.state.auth.rights)
</script>
